import React, { FC } from "react";

const EditableField: FC<{
  type?: string;
  field: string;
  value: string;
  placeholder: string;
  onFieldChange?: (field: string, value: string) => void;
}> = ({ type = "text", field, value, placeholder, onFieldChange = () => {} }) => (
  <div>
    <input
      type={type}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onFieldChange(field, e.currentTarget.value)}
    />
    {/* language=CSS */}
    <style jsx>{`
      input {
        border: 1px solid rgb(194, 194, 194);
        padding: 8px 14px;
        font-size: 1em;
        width: 100%;
        margin-top: 5px;
      }
    `}</style>
  </div>
);

export default EditableField;
